import React from "react";

import { Metric } from "components/Utils/Utils.js";
import Heading from "components/Elements/Heading";

const MarqueeTVViewershipSummary = (props) => {
  const { data } = props;

  return (
    <div className="row mt-2 d-flex align-items-end">
      {data.total_entitlements_yesterday && (
        <div className="col mb-3">
          <Heading size={6} className={"mb-1"}>
            Total Entitlements Yesterday
          </Heading>
          <Metric {...data.total_entitlements_yesterday} size={"md"} />
        </div>
      )}

      {data.watched_90 && (
        <div className="col-6 col-md mb-3">
          <Heading size={6} className={"mb-1"}>
            Watched 1-30 min
          </Heading>
          <Metric {...data.watched_90} size={"md"} />
        </div>
      )}

      {data.watched_30_90 && (
        <div className="col-6 col-md mb-3">
          <Heading size={6} className={"mb-1"}>
            Watched 30-90 min
          </Heading>
          <Metric {...data.watched_30_90} size={"md"} />
        </div>
      )}

      {data.watched_1_30 && (
        <div className="col-6 col-md mb-3">
          <Heading size={6} className={"mb-1"}>
            Watched 90+min
          </Heading>
          <Metric {...data.watched_1_30} size={"md"} />
        </div>
      )}

      {data.non_watchers && (
        <div className="col-6 col-md mb-3">
          <Heading size={6} className={"mb-1"}>
            Non-Watchers
          </Heading>
          <Metric {...data.non_watchers} size={"md"} />
        </div>
      )}
    </div>
  );
};

export default MarqueeTVViewershipSummary;
